import { render, staticRenderFns } from "./history_modal.vue?vue&type=template&id=0980d2b0&scoped=true"
import script from "./history_modal.vue?vue&type=script&lang=js"
export * from "./history_modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0980d2b0",
  null
  
)

export default component.exports